import getters from './getters'
import actions from './actions'
import mutations from './mutations'
const state = {
    serviceRequestLabors : [],
    serviceRequestLabor : {
    },
    
}
const serviceRequestLabor = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default serviceRequestLabor;